// Tipos del "Ecosistema musical" (el rol interno sigue llamándose "artista").
//
// Se agrupan en dos familias porque no representan lo mismo:
//
//   - Individuales: el perfil ES el proyecto. Un solista o una banda
//     difunden lo suyo, así que un género principal alcanza para
//     describirlos.
//   - Multiartista: el perfil GESTIONA proyectos de terceros. Un sello, un
//     manager o un label representan a varios artistas a la vez, y su
//     catálogo abarca varios géneros.
//
// Esa separación es también la base de las herramientas de gestión de
// múltiples artistas planificadas (ver PLANIFICACION_2.md).

// Influencer, Youtuber y Streamer estuvieron acá hasta 2026-09-28; pasaron
// a ser tipos de difusor (utils/tiposDifusor.js) porque difunden música de
// terceros en vez de la propia.
export const TIPOS_INDIVIDUALES = ["Solista", "Grupo Musical"];

export const TIPOS_MULTIARTISTA = [
  "Sello Discográfico",
  "Manager o RP",
  "Label",
];

export const TIPOS_ARTISTA = [...TIPOS_INDIVIDUALES, ...TIPOS_MULTIARTISTA];

// Opciones del selector de tipo en el perfil de un artista ya registrado.
// Si su tipo guardado dejó de ser válido (un "Influencer" registrado antes
// de que pasara a difusor), se lo agrega al final para que el selector no
// aparezca vacío y el perfil no pierda el dato hasta que se lo reasigne.
export function opcionesTipoArtista(tipoActual) {
  const actual = String(tipoActual || "").trim();
  if (!actual) return TIPOS_ARTISTA;
  const existe = TIPOS_ARTISTA.some(
    (item) => normalizarTipo(item) === normalizarTipo(actual)
  );
  return existe ? TIPOS_ARTISTA : [...TIPOS_ARTISTA, actual];
}

// Cuántos géneros musicales puede registrar cada familia.
export const MAX_GENEROS_INDIVIDUAL = 1;
export const MAX_GENEROS_MULTIARTISTA = 10;

// El tipo se guarda como texto libre y en la base conviven variantes de
// perfiles cargados antes de unificar la lista ("Sello discográfico",
// "sello discografico"), así que se compara sin acentos ni mayúsculas.
const normalizarTipo = (tipo) =>
  String(tipo || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

export function gestionaMultiplesArtistas(tipo) {
  const buscado = normalizarTipo(tipo);
  return TIPOS_MULTIARTISTA.some((item) => normalizarTipo(item) === buscado);
}

export function maxGeneros(tipo) {
  return gestionaMultiplesArtistas(tipo)
    ? MAX_GENEROS_MULTIARTISTA
    : MAX_GENEROS_INDIVIDUAL;
}

// generos_musicales llega como array, string JSON o string plano según de
// dónde venga el perfil (el multipart del registro manda un solo género como
// string y varios como array). Devuelve siempre un array.
export function normalizeGeneros(valor) {
  if (Array.isArray(valor)) return valor.filter(Boolean);
  if (typeof valor === "string" && valor.trim()) {
    try {
      const parsed = JSON.parse(valor);
      if (Array.isArray(parsed)) return parsed.filter(Boolean);
      return parsed ? [String(parsed)] : [];
    } catch {
      return [valor];
    }
  }
  return [];
}
